module.exports = __webpack_public_path__ + "static/media/active_agencies.5525b1f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/active_agencies.svg
// module id = 2700
// module chunks = 0